import React from 'react';

const SIDEBAR_WIDTH = 260;
const NAVBAR_HEIGHT = 60; // match your navbar/topbar height
const TOP_GAP = 12;

const AdminSidebar = ({ section, setSection }) => {
  const item = (key, label) => (
    <button
      onClick={() => setSection(key)}
      style={{
        display: 'block',
        width: '100%',
        padding: '10px 12px',
        textAlign: 'left',
        background: section === key ? '#e8f0ff' : 'transparent',
        border: 'none',
        cursor: 'pointer'
      }}
    >
      {label}
    </button>
  );

  return (
    <aside
      style={{
        position: 'fixed',
        top: NAVBAR_HEIGHT + TOP_GAP,
        left: 0,
        width: SIDEBAR_WIDTH,
        height: `calc(100vh - ${NAVBAR_HEIGHT + TOP_GAP}px)`,
        borderRight: '1px solid #eee',
        padding: 12,
        background: '#fff',
        overflow: 'auto',
        zIndex: 900
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 12 }}>Admin</div>
      {item('users', 'User List')}
      {item('consultants', 'Consultant List')}
      {item('assign', 'Consultant Assignment')}
      {item('settings', 'Settings')}
    </aside>
  );
};

export default AdminSidebar;